import { getCurrentSessionId } from '@heidi/runtime/shell';
import { SidePanelState } from '@heidi/schema/ml-scribe';
import { atom, getDefaultStore } from 'jotai';

import type { VoiceSidePanel, VoiceUiActionsPort } from './voice-ui-actions.port';

/**
 * Pending panel open for when we navigate to another session first
 * (same pattern as ``voiceSessionFocusAtom`` for tabs).
 */
export type VoiceSessionPanelRequest = {
  sessionId: string;
  panel: VoiceSidePanel;
  requestedAt: number;
};

export const voiceSessionPanelAtom = atom<VoiceSessionPanelRequest | null>(null);

export const sidePanelFromOpenArtifact = (
  type: string | undefined
): VoiceSidePanel | null => {
  if (type === 'tasks') return SidePanelState.TASKS;
  if (type === 'codes') return SidePanelState.EMBEDDINGS;
  return null;
};

/**
 * Open the tasks or codes side panel on classic V1 session layout
 * (``activePanelAtom``). V2 Labs cards ignore that atom — follow-up.
 */
export const applySessionSidePanel = (
  sessionId: string,
  panel: VoiceSidePanel,
  port: VoiceUiActionsPort
): void => {
  if (panel === SidePanelState.EMBEDDINGS) {
    port.setEmbeddingsPanelSessionId(sessionId);
  }
  port.setActiveSessionPanel(panel);
};

/**
 * Open now when already on the target session; otherwise stash for the
 * mount hook after ``Router.push`` lands.
 */
export const requestSessionSidePanel = (
  sessionId: string,
  panel: VoiceSidePanel,
  port: VoiceUiActionsPort
): void => {
  const store = getDefaultStore();
  store.set(voiceSessionPanelAtom, {
    sessionId,
    panel,
    requestedAt: Date.now(),
  });
  if (sessionId === getCurrentSessionId()) {
    applySessionSidePanel(sessionId, panel, port);
    store.set(voiceSessionPanelAtom, null);
  }
};
